import OTP_validation from "./OTP_validation";
import './otp_validation.scss';

export default OTP_validation;